<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<svg
   xmlns="http://www.w3.org/2000/svg"
   xml:space="preserve"
   viewBox="4 12 22 6"
   y="0px"
   x="0px"
   id="company"
   version="1.1"><path
     d="M 10,10 10,9 C 10,8.4 9.6,8 9,8 L 8,8 C 7.4,8 7,8.4 7,9 l 0,1 c -0.6,0 -1,0.4 -1,1 l 0,11 5,0 0,-11 c 0,-0.6 -0.4,-1 -1,-1 z m -2,9 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 2,6 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z"
     id="path5"
     style="fill:currentColor;fill-opacity:1" /><path
     d="M 23,10 23,9 C 23,8.4 22.6,8 22,8 L 21,8 21,4.5 C 21,4.2 20.8,4 20.5,4 20.2,4 20,4.2 20,4.5 L 20,8 19,8 c -0.6,0 -1,0.4 -1,1 l 0,1 c -0.6,0 -1,0.4 -1,1 l 0,11 7,0 0,-11 c 0,-0.6 -0.4,-1 -1,-1 z m -4,9 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-4 1,0 0,1 -1,0 0,-1 z m 2,10 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-4 1,0 0,1 -1,0 0,-1 z m 2,10 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z m 0,-2 -1,0 0,-1 1,0 0,1 z"
     id="path7"
     style="fill:currentColor;fill-opacity:1" /><path
     d="m 15,12 c 0,-0.6 -0.4,-1 -1,-1 -0.6,0 -1,0.4 -1,1 -0.6,0 -1,0.4 -1,1 l 0,9 4,0 0,-9 c 0,-0.6 -0.4,-1 -1,-1 z m -2,4 1,0 0,1 -1,0 0,-1 z m 2,3 -1,0 0,-1 1,0 0,1 z m 0,-4 -1,0 0,-1 1,0 0,1 z"
     id="path9"
     style="fill:currentColor;fill-opacity:1" /></svg>
